/**
 * Configuration des URLs API
 * Ce fichier sélectionne automatiquement les bonnes URLs en fonction de l'environnement
 */

// Détermine si l'application est en production
const isProduction = process.env.NODE_ENV === 'production';

const normalizeBaseUrl = (value) => (value || '').trim().replace(/\/+$/, '');

// Configuration des URLs
const config = {
  // URL de l'API
  apiUrl: normalizeBaseUrl(isProduction
    ? process.env.REACT_APP_PROD_API_URL 
    : process.env.REACT_APP_API_URL),
  
  // Autres configurations qui pourraient être nécessaires
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};

// Point d'entree unique pour eviter qu'un composant de production utilise par
// erreur REACT_APP_API_URL (souvent configure sur localhost pour le dev).
export const apiEndpoint = (path = '') => {
  if (!config.apiUrl) {
    throw new Error('URL du serveur API non configurée pour cet environnement');
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${config.apiUrl}${normalizedPath}`;
};

// Log de configuration en développement uniquement
if (!isProduction) {
  console.log('🔧 Configuration API:', {
    environment: process.env.NODE_ENV,
    apiUrl: config.apiUrl
  });
}

export default config;
